import Features, {tillsammansPush} from "@atg-shared/client-features";
import {fetchSaga} from "@atg-shared/fetch-redux";
import {runLazySaga} from "@atg-shared/lazy-store";
import {
    appSaga,
    appPersonalizationSaga,
    memberCustomizationSaga,
    trackingSaga,
} from "@atg-tillsammans/app-data-access/redux";
import {callAuthSaga} from "@atg-tillsammans/auth";
import sportBetSaga from "@atg-tillsammans/bet-data-access/sport/redux/sportBetSaga";
import gameSaga from "@atg-tillsammans/game-data-access/common/redux/gameSaga";
import {tillsammansPushSaga} from "@atg-tillsammans/push-data-access";
import {tillsammansPushNotificationSaga} from "@atg-tillsammans/push-feature";
import {roundSaga} from "@atg-tillsammans/round-data-access";
import {teamChatSaga as chatSaga} from "@atg-tillsammans/team-chat-data-access";
import {inviteSaga} from "@atg-tillsammans/team-data-access/redux/invite";
import {teamSaga} from "@atg-tillsammans/team-data-access/redux/team";
import {teamMemberSaga} from "@atg-tillsammans/team-member-data-access";
import {personalizationSaga} from "@atg-tillsammans-shared/personalization-data-access";
import {sharedBetSaga} from "@atg-tillsammans-shared/shared-bet-data-access";
import toastSaga from "atg-ui-toast/domain/toastSaga";

import type {LazyStore} from "@atg-shared/lazy-store";
import type {Action} from "redux";

export default function rootSaga(store: LazyStore<unknown, Action>) {
    runLazySaga(store, appSaga);
    runLazySaga(store, memberCustomizationSaga);
    runLazySaga(store, fetchSaga);
    runLazySaga(store, teamSaga);
    runLazySaga(store, inviteSaga);
    runLazySaga(store, sportBetSaga);
    runLazySaga(store, personalizationSaga);
    runLazySaga(store, toastSaga);
    runLazySaga(store, gameSaga, store);
    runLazySaga(store, chatSaga, store.dispatch);
    if (Features.isEnabled(tillsammansPush)) {
        runLazySaga(store, tillsammansPushSaga, store.dispatch);
        runLazySaga(store, tillsammansPushNotificationSaga);
    }
    runLazySaga(store, callAuthSaga);
    runLazySaga(store, trackingSaga);
    runLazySaga(store, roundSaga);
    runLazySaga(store, sharedBetSaga);
    runLazySaga(store, appPersonalizationSaga);
    runLazySaga(store, teamMemberSaga);
}
